import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';

const BASE_URL: string = environment.API_URL;
const httpOptions: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json');



@Injectable({
    providedIn: 'root'
})
export class ProductsService {
    public uploadFile2(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadfile`, formData);
    }
    
    // Actualiza el perfil de usuario
    public updateProfile(id: number | string, body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/user/${id}`, body, { headers });
    }
    updateTopic(id: any, newtopic: { videoUrl: any; FileName: string; FileSize: String; Type: string; }) {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/altertopics/${id}`, newtopic, { headers });
    }
    
    postCampaign(body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/campaigns`, body);
    }

    getCampaignDetails(id: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/campaign-details/${id}`);
    }

    putCampaign(id: any, body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/campaign-details/${id}`, body);
    }

    public currentUser: any;
    httpOption: any;

    uploadVideo(formData: FormData) {
        return this.http.put<any>(`${BASE_URL}/upload-video`, formData);
    }


    constructor(
        private http: HttpClient,
        private router: Router
    ) {
        this.currentUser = this.userValue;
    }

    public get userValue(): any {
        return JSON.parse(localStorage.getItem('currentUser') ?? '{}');
    }

    public uploadImg(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();

        // Validación rápida del archivo cuando sea posible (tipo y tamaño)
        try {
            if (typeof FormData !== 'undefined' && formData instanceof FormData) {
                let file: File | null = null;
                // Intentar campos comunes
                const commonKeys = ['file', 'image', 'photo', 'avatar'];
                for (const k of commonKeys) {
                    const v = formData.get(k);
                    if (v instanceof File) { file = v; break; }
                }
                // Si no se encontró por clave, buscar el primer File en el FormData
                if (!file) {
                    (formData as FormData).forEach((value) => {
                        if (!file && value instanceof File) file = value;
                    });
                }

                if (file) {
                    const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
                    const maxBytes = 5 * 1024 * 1024; // 5 MB
                    const mime = (file.type || '').toLowerCase();
                    const name = (file.name || '').toLowerCase();
                    const extAllowed = ['.jpg', '.jpeg', '.png', '.webp'];
                    const hasAllowedMime = allowed.includes(mime);
                    const hasAllowedExt = extAllowed.some(e => name.endsWith(e));

                    if (!hasAllowedMime && !hasAllowedExt) {
                        return throwError(() => ({
                            status: 400,
                            message: 'Formato no permitido. Usa JPG, PNG o WEBP.'
                        }));
                    }
                    if (file.size > maxBytes) {
                        return throwError(() => ({
                            status: 400,
                            message: 'La imagen supera el límite de 5 MB.'
                        }));
                    }
                }
            }
        } catch { /* Silencioso: si falla validación, no bloquear */ }

        // Nuevo endpoint específico para subir imagen de perfil
        return this.http.post<any>(`${BASE_URL}/uploadimg`, formData, { headers })
            .pipe(
                catchError((err) => {
                    // Mapear errores comunes a mensajes claros
                    const status = err?.status;
                    const msg = err?.error?.message || err?.message;
                    if (status === 413) {
                        return throwError(() => ({ status, message: 'El archivo es demasiado grande para el servidor.' }));
                    }
                    if (status === 400 && msg) {
                        // Mantener mensaje del backend si es descriptivo
                        return throwError(() => ({ status, message: msg }));
                    }
                    return throwError(() => ({ status: status || 500, message: msg || 'No se pudo subir la imagen.' }));
                })
            );
    }

    /**
     * Sube una imagen de perfil usando la nueva API auth/profile/photo
     * @param formData FormData con el archivo de imagen (campo: 'photo')
     * @returns Observable con la respuesta que incluye la URL de la imagen subida
     */
    public uploadProfilePhoto(formData: FormData): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/auth/profile/photo`, formData, { headers })
            .pipe(
                catchError((err) => {
                    const status = err?.status;
                    const msg = err?.error?.message || err?.message;
                    if (status === 413) {
                        return throwError(() => ({ status, message: 'El archivo es demasiado grande para el servidor.' }));
                    }
                    if (status === 400 && msg) {
                        return throwError(() => ({ status, message: msg }));
                    }
                    return throwError(() => ({ status: status || 500, message: msg || 'No se pudo subir la imagen de perfil.' }));
                })
            );
    }

    // Utilidad opcional: validar archivo de imagen de perfil antes de construir FormData
    public validateProfileImageFile(file: File, options?: { maxMB?: number, allowedMime?: string[] }): { valid: boolean; error?: string } {
        try {
            if (!(file instanceof File)) return { valid: false, error: 'Archivo inválido.' };
            const maxBytes = Math.max(1, Math.floor((options?.maxMB ?? 5))) * 1024 * 1024;
            const allowed = (options?.allowedMime && options.allowedMime.length > 0)
                ? options.allowedMime
                : ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
            const mime = (file.type || '').toLowerCase();
            const name = (file.name || '').toLowerCase();
            const extAllowed = ['.jpg', '.jpeg', '.png', '.webp'];
            const hasAllowedMime = allowed.includes(mime);
            const hasAllowedExt = extAllowed.some(e => name.endsWith(e));
            if (!hasAllowedMime && !hasAllowedExt) return { valid: false, error: 'Formato no permitido. Usa JPG, PNG o WEBP.' };
            if (file.size > maxBytes) return { valid: false, error: `La imagen supera el límite de ${(maxBytes / (1024 * 1024))|0} MB.` };
            return { valid: true };
        } catch {
            return { valid: false, error: 'No fue posible validar la imagen.' };
        }
    }

    setCoursePreview(uuid: string, id: number) {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/masteracc/${uuid}`, { productid: id }, { headers });
    }

    validateActivation(productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/validate-products/${productId}`, { headers });
    }

    public uploadFile(formData: any, productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/saveDocument/${productId}`, formData, { headers });
    }

    public uploadFileWithoutID(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadarchive`, formData, { headers });
    }



    public createFeature(feature: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/catalogs`, feature, { headers });
    }

    public updateFeature(id: number, feature: any): Observable<any> {
        const buildFeature = this.editFeature(feature);
        const updatedFeature = this.addBackendStructureFeature(buildFeature);
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/catalog/${id}`, updatedFeature, { headers });
    }

    public getFeatures(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Feature'}`, { headers });
    }

    public deleteFeature(id: number): Observable<any> {
        return this.http.delete<any>(`${BASE_URL}/catalog/${id}`);
    }



    public getCatalogs(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs`, { headers });
    }

    public getCatalogsName(name): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${name}`, { headers });
    }

    public postCatalogs(body): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/catalogs/`, body, { headers });
    }

    public getValuestoCatalog(Catalog: string): Observable<any> {
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${Catalog}`);
    }

    public getValue(id: string | number): Observable<any> {
        return this.http.get<any>(`${BASE_URL}/catalog/${id}`);
    }

    public getCatalogsAlias(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-alias`, { headers });
    }

    public getSpecifications(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Specification'}`, { headers });
    }

    public getFamilies(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Family'}`, { headers });
    }

    public getCategories(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Category'}`, { headers });
    }

    public getCatalog(name: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${name}`, { headers });
    }

    public getSubCategories(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Subcategory'}`, { headers });
    }

    public getCourses(page: number = 1, limit: number = 10): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/courses?page=${page}&limit=${limit}`, { headers });
    }

    public getCourses2(search: string, id: any, page: number = 1, limit: number = 10): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/courses?page=${page}&limit=${limit}&search=${search}&user_id=${id}`, { headers });
    }

    // Método flexible para obtener cursos con parámetros personalizados
    public getCoursesWithParams(params: { page?: number, limit?: number, search?: string, user_id?: any }): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        const queryParams = new URLSearchParams();
        
        queryParams.append('page', (params.page || 1).toString());
        queryParams.append('limit', (params.limit || 10).toString());
        
        if (params.search) {
            queryParams.append('search', params.search);
        }
        if (params.user_id) {
            queryParams.append('user_id', params.user_id.toString());
        }
        
        return this.http.get<any>(`${BASE_URL}/courses?${queryParams.toString()}`, { headers });
    }

    public getCapacitations(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products?Family=${'Capacitation'}`);
    }

    public getWebinars(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products?Family=${'Webinar'}`);
    }
    public getEvents(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products?Family=${'Event'}`);
    }

    public deleteCourses(productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/course/${productId}`, { headers });
    }

    public getProduct(productId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/course/${productId}`, { headers });
    }

    public getCourseById(courseId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/course/${courseId}`, { headers });
    }

    public getVideotecaLista(productId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        // Adjuntar user_id si está disponible en localStorage, ya que algunos backends lo requieren para scoping
        let url = `${BASE_URL}/products/videoteca/${productId}`;
        try {
            const raw = localStorage.getItem('currentUser');
            if (raw) {
                const user = JSON.parse(raw || '{}');
                const uid = user?.id ?? user?.user_id;
                if (uid != null) {
                    const sep = url.includes('?') ? '&' : '?';
                    url = `${url}${sep}user_id=${encodeURIComponent(uid)}`;
                }
            }
        } catch {}
        return this.http.get<any>(url, { headers });
    }

    public deleteModulos(studyprogramId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/deactivate/${studyprogramId}`, { headers });
    }

    public deleteLecciones(topicId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/deleteTopics/${topicId}`, { headers });
    }
    
    public getVideos(body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/onboarding/getVideoByName`, body);
    }

    public changeStatusVideo(videoId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/onboarding/finishVideo/${videoId}`, { headers });
    }

    public getActiveNews(): Observable<any[]> {
        return this.http.get<any[]>(`${BASE_URL}/newstoshow`);
    }

    public getProductsFiltered(family: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products-filter?family=${family}`);
    }

    public createCourse(product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/course`, product, { headers });
    }

    public createVideoteca(product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/products`, product, { headers });
    }

    public getVideoteca(search: string, id: any): Observable<any> {
        // Validar parámetros
        if (!id || id === 'undefined' || id === 'null') {
            console.error('ID inválido en getVideoteca:', id);
            return throwError(() => new Error('ID de usuario inválido'));
        }

        const headers: HttpHeaders = getHeaders();
        const url = `${BASE_URL}/products?Family=Videoteca&user_id=${id}`;
        
        console.log('Llamando getVideoteca con URL:', url);
        
        return this.http.get<any>(url, { headers });
    }

    public updateCourse(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${id}`, product, { headers });
    }

    public updateCourse2(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${id}`, product, { headers });
    }

    public deleteProduct(id: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<Observable<any>>(`${BASE_URL}/products/${id}`, { headers });
    }

    postModules(body: any): Observable<any> {
        if (this.currentUser) { // Asegúrate de que `this.currentUser` contenga el token de autenticación
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token, // Agrega 'Bearer' antes del token
                    'Content-Type': 'application/json'
                })
            };

            // Realiza la solicitud POST con los encabezados de autenticación
            return this.http.post<any>(`${BASE_URL}/studyprogram`, body, httpOptions);
        } else {
            // Manejo del caso en que `currentUser` es nulo
            console.error('Usuario no autenticado');
            return throwError('Usuario no autenticado');
        }
    }

    public postModule0(Property, Value, ProductId): Observable<any> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            // this.httpOption = httpOptions.set('Authorization', this.currentUser.token);
            return this.http.post<any>(`${BASE_URL}/info-product`, { Property, Value, ProductId }, httpOptions);
        }

    }

    uploadVideoModulo(formData: FormData): Observable<HttpEvent<any>> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                }),
                reportProgress: true,  // Para obtener el progreso de la subida
                observe: 'events' as const, // Aseguramos que observe es de tipo 'events'
                responseType: 'json' as const  // Para asegurarnos de que la respuesta sea JSON
            };
    
            return this.http.put<any>(`${BASE_URL}/upload-video`, formData, {
                headers: httpOptions.headers,
                reportProgress: httpOptions.reportProgress,
                observe: httpOptions.observe,
                responseType: httpOptions.responseType
            });
        }
    }       

    public uploadResource(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadfile`, formData, { headers });
    }

    public postResource(Property: string, Value: string, Commentary: string, ProductId: number, FileName: string, FileSize: number, Type: string): Observable<any> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            
            // Crear el cuerpo del POST con los nuevos campos
            const body = {
                Property,
                Value,
                Commentary,
                ProductId,
                FileName,  // Nombre del archivo
                FileSize,  // Tamaño del archivo
                Type   // Tipo/Extensión del archivo
            };

            // Verificar el cuerpo antes de enviar
            console.log('Body de la solicitud:', body);
            
            // Realizar el POST incluyendo los nuevos datos
            return this.http.post<any>(`${BASE_URL}/info-product`, body, httpOptions);
        }
    }
    

    public postContent(Property, Value, Commentary, ProductId): Observable<any> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            // this.httpOption = httpOptions.set('Authorization', this.currentUser.token);
            return this.http.post<any>(`${BASE_URL}/info-product`, { Property, Value, Commentary, ProductId }, httpOptions);
        }
    }

    public mapRequiredValues(product: any): any {
        //console.log(product);
        const productInfo: any = {};

        {
            productInfo.id = product.id;
            // Manejar Category que puede venir como ID o como objeto
            productInfo.Category = product.Category || product.category_id || product.Category_id || null;
            productInfo.SKU = product.SKU || '';
            productInfo.Title = product.Title || '';
            productInfo.Description = product.Description || '';
            productInfo.UnitPrice = product.UnitPrice || 0;
            productInfo.CurrencyCode = product.CurrencyCode || 'MXN';
            productInfo.ImgFileUrl = product.ImgFileUrl || '';
            productInfo.CourseModel = product.CourseModel || '';
            productInfo.Objective = product.Objective || '';
            productInfo.Introduction = product.Introduction || '';
            // Manejar Level que puede venir como ID o como objeto
            productInfo.Level = product.Level || product.level_id || product.Level_id || null;
            productInfo.TotalHours = product.TotalHours || 0;
            productInfo.Language = product.Language || 'Español';
            productInfo.LanguageSubtitles = product.LanguageSubtitles || '';
            productInfo.AccessType = product.AccessType || '';
            productInfo.TargetMarket = product.TargetMarket || '';
            productInfo.FileUrl = product.FileUrl || '';
            productInfo.DiscountPrice = product.DiscountPrice || 0;
            productInfo.StartDate = product.StartDate || null;
            productInfo.EndDate = product.EndDate || null;
            productInfo.Teacher = product.Teacher || null;
            productInfo.Percentage = product.Percentage || 0;
            productInfo.Name = product.Name || '';
            productInfo.numberTopics = product.numberTopics || 0;
            productInfo.courseDuration = product.courseDuration || '';
            productInfo.SubCategory = product.SubCategory || product.subcategory_id || '';
            productInfo.teacher_name = product.teacher_name || '';
        }

        return productInfo;
    }

    private editProduct(product: any): any {
        // console.log(product);
        const editProduct = {
            Title: product.Title,
            Family: product.Family,
            Category: product.Category,
            SubCategory: product.SubCategory,
            Brand: product.Brand,
            SKU: product.SKU,
            Model: product.Model,
            Description: product.Description,
            UnitPrice: product.UnitPrice,
            DiscountPrice: product.DiscountPrice,
            CurrencyCode: product.CurrencyCode,
        };
        return editProduct;
    }

    private addBackendStructure(product: any) {
        return {
            Title: product.Title,
            Family: product.Family,
            Category: product.Category,
            SubCategory: product.SubCategory,
            Brand: product.Brand,
            SKU: product.SKU,
            Model: product.Model,
            Description: product.Description,
            UnitPrice: product.UnitPrice,
            DiscountPrice: product.DiscountPrice,
            CurrencyCode: product.CurrencyCode,
            ProductInfo: product.ProductInfo
        };
    }

    private editFeature(feature: any): any {
        const editFeature = {
            CatalogName: feature.CatalogName,
            ValueAlpha: feature.ValueAlpha,
        };
        return editFeature;
    }

    private addBackendStructureFeature(feature: any) {
        return {
            CatalogName: feature.CatalogName,
            ValueAlpha: feature.ValueAlpha
        };
    }

    public inicializarCurso(body: any): Observable<any> {
        if (this.currentUser) {
            const userid = this.currentUser.id;
            body.userid = userid;
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            // console.log(httpOptions);
            // this.httpOption = httpOptions.set('Authorization', this.currentUser.token);
            // return this.http.post<any>(BASE_URL + '/init-product', { headers: this.httpOption });
            return this.http.post<any>(`${BASE_URL}/init-product`, body, httpOptions);
        }
        // const headers: HttpHeaders = getHeaders()
    }

    public guardarRespuestaGPT(Property, Value, ProductId): Observable<any> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            // this.httpOption = httpOptions.set('Authorization', this.currentUser.token);
            return this.http.post<any>(`${BASE_URL}/info-product`, { Property, Value, ProductId }, httpOptions);
        }

    }
    public editarRespuestaGPT(id, Property, Value, ProductId): Observable<any> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            // this.httpOption = httpOptions.set('Authorization', this.currentUser.token);
            return this.http.put<any>(`${BASE_URL}/info-product`, { id, Property, Value, ProductId }, httpOptions);
        }

    }

    public porcentajeCracionCurso(id, CoursePct): Observable<any> {
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            }
            return this.http.put<any>(`${BASE_URL}/products`, { id, CoursePct }, httpOptions);
        }

    }
    public enviarloanding(body): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/v2/info-product`, body, { headers });
    }

    public uploadVideoVideoteca(formData: FormData): Observable<HttpEvent<any>> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadfile`, formData, {
          headers,
          reportProgress: true, // Habilitar el seguimiento del progreso
          observe: 'events',    // Observar eventos HTTP (incluido el progreso)
        });
    }      
    
    public setProductInfo(body: any){
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/info-product`, body, { headers });
    }
    // public  updateProfile(body: any): Observable<any> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.post<any>(`${BASE_URL}/user-profile`, body, { headers });
    // }
    
    getInstructor(limit: number, offset: number, q: string): Observable<any> {
        /* const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/teachers?limit=${limit}&offset=${offset}&q=${q}`, { headers }); */
        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            // this.httpOption = httpOptions.set('Authorization', this.currentUser.token);
            //return this.http.get<any>(`${BASE_URL}/teachers?limit=${limit}&offset=${offset}&q=${q}`, httpOptions);
            let params = [];
            if (limit !== null && limit !== undefined) params.push(`limit=${limit}`);
            if (offset !== null && offset !== undefined) params.push(`offset=${offset}`);
            if (q !== null && q !== undefined) params.push(`q=${encodeURIComponent(q)}`);

            const queryString = params.length > 0 ? `?${params.join('&')}` : '';

            return this.http.get<any>(`${BASE_URL}/teachers${queryString}`, httpOptions);
        }
    }
    getAllInstructor( q: string): Observable<any> {

        if (this.currentUser) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };

            let params = [];
            if (q !== null && q !== undefined) params.push(`q=${encodeURIComponent(q)}`);

            const queryString = params.length > 0 ? `?${params.join('&')}` : '';

            return this.http.get<any>(`${BASE_URL}/allTeachers${queryString}`, httpOptions);
        }
    }

    listByRole(limit: number, offset: number, q: string, role: string) {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/users-by-role/${role}?limit=${limit}&offset=${offset}&q=${q}`, { headers });
    }

    // Nuevo método específico para obtener estudiantes
    getStudents(limit: number, offset: number, q: string = '') {
        const headers: HttpHeaders = getHeaders();
        let params = new HttpParams()
            .set('limit', limit.toString())
            .set('offset', offset.toString());
        
        if (q && q.trim() !== '') {
            params = params.set('q', q);
        }
        
        return this.http.get<any>(`${BASE_URL}/students`, { headers, params });
    }

    public addCollaborator(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/collaborators/addcollaborator`, body, { headers });
    }
   
    public disableCollaborator(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/collaborators/disableCollaborator`, body, { headers });
    }
    
    public enableCollaborator(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/collaborators/enableCollaborator`, body, { headers });
    }

    public listTeacherRelatedWith(userId: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/collaborators/listTeachersRelatedWith/${userId}`, { headers });
    }
    
    public listCollabsRelatedWith(userId: any, limit: number, offset: number, search: string) {
        const headers: HttpHeaders = getHeaders();
        // Nota: userId ya no es requerido por el nuevo endpoint, pero se mantiene en la firma para compatibilidad

        // Algunos servicios usan 'q' en lugar de 'search': enviaremos ambos por compatibilidad
        let params = new HttpParams()
            .set('limit', (limit ?? 10).toString())
            .set('offset', (offset ?? 0).toString());
        if (search !== undefined && search !== null) {
            params = params.set('q', search).set('search', search);
        }

        // Nuevo endpoint para listar colaboradores/usuarios de negocio
        return this.http.get<any>(`${BASE_URL}/business/users`, { headers, params });
    }    

    setLandingLayout(data: { id: number, landinglayout: string }) {
        return this.http.post(`${BASE_URL}/setLandingLayout`, data);
    }

    // En products.service.ts
    getVideotecas(userId: string) {
        // Validar que userId no sea null o undefined
        if (!userId || userId === 'undefined' || userId === 'null') {
            console.error('userId inválido en getVideotecas:', userId);
            return throwError(() => new Error('ID de usuario inválido'));
        }

        const headers: HttpHeaders = getHeaders();
        const params = new HttpParams()
            .set('Family', 'Videoteca')
            .set('search', 'Videoteca')
            .set('user_id', userId.toString());
    
        console.log('Llamando getVideotecas con parámetros:', {
            Family: 'Videoteca',
            search: 'Videoteca',
            user_id: userId
        });

        return this.http.get<any>(`${BASE_URL}/productVideoteca/getVideotecas`, { headers, params });
    }

    updateVideoFromVideoteca(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post(`${BASE_URL}/Videoteca/UpdateVideo/${body.id}`, body, { headers });
    }

    asignarVideoteca(data: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post(`${BASE_URL}/teacherCollabVideoteca`, data, { headers });
    }

    getVideotecaByCollabAndInstructor(instructorId: number, collaboratorId: number) {
        const headers: HttpHeaders = getHeaders();
        return this.http.get(`${BASE_URL}/VideotecaByCollabId2?tid=${instructorId}&cid=${collaboratorId}`, { headers });
    }

    updateCollaborator(body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put(`${BASE_URL}/TeacherCollaborator`, body, { headers });
    }

    // Crear estudiante con envío de email de confirmación
    createStudent(studentData: any): Observable<any> {
        console.log('🌐 [PRODUCTS-SERVICE] Enviando datos de estudiante al backend:', studentData);
        const headers: HttpHeaders = getHeaders();
        
        // En implementación real, esto debería ir a un endpoint específico
        // Por ahora simularemos la creación local
        return new Observable(observer => {
            // Simular delay de red
            setTimeout(() => {
                try {
                    // Simular validación del backend
                    if (!studentData.email || !studentData.firstName || !studentData.lastName) {
                        observer.error({ 
                            status: 400, 
                            message: 'Faltan campos obligatorios' 
                        });
                        return;
                    }

                    // Simular verificación de email duplicado
                    const existingStudents = JSON.parse(localStorage.getItem('students') || '[]');
                    const emailExists = existingStudents.find((s: any) => s.email === studentData.email);
                    
                    if (emailExists) {
                        observer.error({ 
                            status: 409, 
                            message: 'Ya existe un estudiante con este correo electrónico' 
                        });
                        return;
                    }

                    // Crear estudiante
                    const newStudent = {
                        id: Date.now(),
                        ...studentData,
                        createdAt: new Date().toISOString(),
                        status: 'pending_confirmation'
                    };

                    // Guardar en localStorage (simular base de datos)
                    existingStudents.push(newStudent);
                    localStorage.setItem('students', JSON.stringify(existingStudents));

                    // Simular envío de email
                    this.sendConfirmationEmail(newStudent);

                    console.log('✅ [PRODUCTS-SERVICE] Estudiante creado exitosamente:', newStudent);
                    observer.next({
                        success: true,
                        student: newStudent,
                        message: 'Estudiante creado y email enviado'
                    });
                    observer.complete();

                } catch (error) {
                    console.error('❌ [PRODUCTS-SERVICE] Error al crear estudiante:', error);
                    observer.error({ 
                        status: 500, 
                        message: 'Error interno del servidor' 
                    });
                }
            }, 800); // Simular delay de red
        });
    }

    // Simular envío de email de confirmación
    private sendConfirmationEmail(studentData: any): void {
        console.log('📧 [EMAIL] Simulando envío de email de confirmación...');
        
        const emailData = {
            to: studentData.email,
            subject: 'Confirma tu cuenta - Learnify',
            template: 'student-confirmation',
            data: {
                studentName: `${studentData.firstName} ${studentData.lastName}`,
                instructorName: 'Tu Instructor', // En producción obtener del perfil actual
                confirmationUrl: studentData.confirmationUrl,
                welcomeMessage: studentData.sendWelcomeEmail,
                videotecaAccess: studentData.grantVideotecaAccess
            }
        };

        // En producción esto sería una llamada real al servicio de email
        console.log('📧 [EMAIL] Datos del email:', emailData);
        console.log('📧 [EMAIL] Email de confirmación enviado exitosamente a:', studentData.email);
        
        // Simular guardado del log de email
        const emailLogs = JSON.parse(localStorage.getItem('emailLogs') || '[]');
        emailLogs.push({
            ...emailData,
            sentAt: new Date().toISOString(),
            status: 'sent'
        });
        localStorage.setItem('emailLogs', JSON.stringify(emailLogs));
    }

    // ==================== MÉTODOS PARA ESTUDIANTES ====================
    
    public addStudent(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/students/addstudent`, body, { headers });
    }
   
    public disableStudent(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/students/disableStudent`, body, { headers });
    }
    
    public enableStudent(body: any) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/students/enableStudent`, body, { headers });
    }
    
    public listStudentsRelatedWith(userId: any, limit: number, offset: number, search: string) {
        const headers: HttpHeaders = getHeaders();
    
        // Crear los parámetros
        const params = new HttpParams()
            .set('limit', limit.toString())
            .set('offset', offset.toString())
            .set('search', search);
    
        // Realizar la solicitud GET con los parámetros
        return this.http.get<any>(`${BASE_URL}/students/listStudentsRelatedWith/${userId}`, { headers, params });
    }

    getVideotecaByStudentAndInstructor(instructorId: number, studentId: number) {
        const headers: HttpHeaders = getHeaders();
        return this.http.get(`${BASE_URL}/VideotecaByStudentId2?tid=${instructorId}&sid=${studentId}`, { headers });
    }

    updateStudent(body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put(`${BASE_URL}/TeacherStudent`, body, { headers });
    }

    // Listar videotecas (carpetas raíz) del usuario autenticado
    listVideotecas(): Observable<any[]> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any[]>(`${BASE_URL}/videoteca`, { headers });
    }

    // Confirmar invitación a videoteca (singular según contrato)
    confirmVideotecaInvitation(invitationId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post(`${BASE_URL}/videoteca/invitation/${invitationId}`, {}, { headers });
    }

    // Listar invitaciones de videoteca recibidas por el usuario autenticado (endpoint corregido)
    listVideotecaInvitationsReceived(): Observable<any[]> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any[]>(`${BASE_URL}/videotecas/invitations`, { headers });
    }

    // ============ MÉTODOS PARA WIDGETS/MÓDULOS DE EMBUDOS Y LEADS ============

    /** Obtiene los módulos/widgets de un embudo */
    public getFunnelModules(funnelId: number): Observable<any[]> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any[]>(`${BASE_URL}/funnels/${funnelId}/modules`, { headers });
    }

    /** Guarda los módulos/widgets de un embudo */
    public saveFunnelModules(funnelId: number, widgetsData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/funnels/${funnelId}/modules`, widgetsData, { headers });
    }

    /**
     * NOTA: Los siguientes métodos de /leads/:leadId/modules NO EXISTEN en el backend.
     * Para trabajar con valores de campos de leads, usar:
     * - saveLeadFieldValues(leadId, fieldValuesData)
     * - getLeadFieldValues(leadId)
     * 
     * Estos métodos se mantienen comentados por compatibilidad pero NO FUNCIONARÁN.
     */

    // ❌ DEPRECATED - Endpoint no existe en backend
    // public getLeadModules(leadId: number): Observable<any[]> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.get<any[]>(`${BASE_URL}/leads/${leadId}/modules`, { headers });
    // }

    // ❌ DEPRECATED - Endpoint no existe en backend
    // public createLeadModule(leadId: number, moduleData: any): Observable<any> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.post<any>(`${BASE_URL}/leads/${leadId}/modules`, moduleData, { headers });
    // }

    // ❌ DEPRECATED - Endpoint no existe en backend
    // public updateLeadModule(leadId: number, moduleId: number, moduleData: any): Observable<any> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.put<any>(`${BASE_URL}/leads/${leadId}/modules/${moduleId}`, moduleData, { headers });
    // }

    // ❌ DEPRECATED - Endpoint no existe en backend
    // public deleteLeadModule(leadId: number, moduleId: number): Observable<any> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.delete<any>(`${BASE_URL}/leads/${leadId}/modules/${moduleId}`, { headers });
    // }

    // ❌ DEPRECATED - Endpoint no existe en backend
    // public syncLeadModulesFromFunnels(leadId: number, funnelIds: number[]): Observable<any> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.post<any>(`${BASE_URL}/leads/${leadId}/modules/sync`, { funnelIds }, { headers });
    // }
}
